import styles from './button.module.scss';
import iconStyles from './icon.module.scss';
import {Link} from 'react-router-dom';
import React from 'react';
import {classNames} from '../../support/classnames';

interface OwnProps {
    className?: string;
    platform: SocialMediaLoginType;
    to?: string;
    onClick?: () => void;
    children: React.ReactNode;
}

export enum SocialMediaLoginType {
    Facebook = 'facebook',
    Google = 'google',
    Email = 'email',
}

export function SocialButton({className, to, platform, onClick, children}: OwnProps) {
    if (to) {
        return (
            <Link
                to={to}
                style={{paddingRight: '2.6665rem'}}
                className={classNames(className, styles.button, {
                    [styles.facebook]: platform === SocialMediaLoginType.Facebook,
                    [styles.google]: platform === SocialMediaLoginType.Google,
                    [styles.email]: platform === SocialMediaLoginType.Email,
                })}
                viewTransition={true}
            >
                <i
                    className={classNames(iconStyles.icon, {
                        [iconStyles.facebook]: platform === SocialMediaLoginType.Facebook,
                        [iconStyles.google]: platform === SocialMediaLoginType.Google,
                        [iconStyles.email]: platform === SocialMediaLoginType.Email,
                    })}
                />
                <strong>{children}</strong>
            </Link>
        );
    }
    return (
        <button
            style={{paddingRight: '2.6665rem'}}
            className={classNames(className, styles.button, {
                [styles.facebook]: platform === SocialMediaLoginType.Facebook,
                [styles.google]: platform === SocialMediaLoginType.Google,
                [styles.email]: platform === SocialMediaLoginType.Email,
            })}
            onClick={onClick}
        >
            <i
                className={classNames(iconStyles.icon, {
                    [iconStyles.facebook]: platform === SocialMediaLoginType.Facebook,
                    [iconStyles.google]: platform === SocialMediaLoginType.Google,
                    [iconStyles.email]: platform === SocialMediaLoginType.Email,
                })}
            />
            <strong>{children}</strong>
        </button>
    );
}
